<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Calendar Minus" class="d-icon d-icon--calendar-minus" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 9.5A.5.5 0 0 1 8 9h3a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.44 1.94A1.5 1.5 0 0 1 2.5 1.5h1V1a.5.5 0 0 1 1 0v.5h3V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v3.5a.5.5 0 0 1-1 0v-1H2V10a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 1 10V3c0-.398.158-.78.44-1.06Zm8.414.706A.5.5 0 0 1 10 3v1.5H2V3a.5.5 0 0 1 .5-.5h1V3a.5.5 0 0 0 1 0v-.5h3V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .354.146Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCalendarMinus',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
